// my imports
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './component/App';

ReactDOM.render(<App />, document.getElementById('root'));
